import MobileSheet from './MobileSheet';
import { EditIcon, DeleteIcon, CheckIcon } from './Icons';

export default function MobileItemDetailSheet({ editing, onClose, onDelete, onSave, onEdit, children }) {
  return (
    <MobileSheet
      title={editing ? 'Edit Item' : 'Item Details'}
      onClose={onClose}
      showFooter
      footer={
        <div className="mobile-sheet-footer-actions">
          <button className="mobile-btn mobile-btn-danger mobile-btn-sm" onClick={onDelete}>
            <DeleteIcon size={14} /> Delete
          </button>
          {editing ? (
            <button className="mobile-btn mobile-btn-primary mobile-btn-sm" onClick={onSave}>
              <CheckIcon size={14} /> Save
            </button>
          ) : (
            <button className="mobile-btn mobile-btn-secondary mobile-btn-sm" onClick={onEdit}>
              <EditIcon size={14} /> Edit
            </button>
          )}
        </div>
      }
    >
      {children}
    </MobileSheet>
  );
}
